module.exports = __webpack_public_path__ + "static/media/sad.66337948.svg";